<template>
  <business-trip-request-expense-form v-model="expense"
                                      refreshable
                                      @input="change"
                                      @refresh="refresh"
                                      @save="save"
                                      @close="close"
                                      :editable="editable"
                                      v-if="loaded"></business-trip-request-expense-form>
</template>

<script>
import BusinessTripRequestExpenseForm from './BusinessTripRequestExpenseForm'
import _ from 'lodash'
import Vuex from 'vuex'

const btRequestExpensesStore = Vuex.createNamespacedHelpers('BusinessTripRequest/Expenses')
const dialogsStore = Vuex.createNamespacedHelpers('Dialogs')

function getBackRoute (vm) {
  return vm.backRoute || {name: 'business-trip-request-expense', params: {id: vm.id, empid: vm.empid}}
}

export default {
  name: 'business-trip-request-expense-detail',
  components: {
    BusinessTripRequestExpenseForm
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    empid: {
      type: [String, Number],
      required: true
    },
    expid: {
      type: [String, Number],
      required: true
    },
    backRoute: {
      type: [String, Object],
      required: false,
      default: null
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      expense: {},
      modified: false,
      loaded: false
    }
  },
  methods: {
    ...btRequestExpensesStore.mapActions({
      getExpenses: 'getExpenses',
      getExpenseById: 'getExpenseById',
      updateExpense: 'updateExpense'
    }),
    ...dialogsStore.mapActions({
      showConfirmation: 'showConfirmation',
      closeConfirmation: 'closeConfirmation'
    }),
    loadResources () {
      const self = this

      self.getExpenses({vueinstance: self, id: self.id, empid: self.empid})
        .then(res => {
          self.getExpenseById({vueinstance: self,
            id: self.id,
            empid: self.empid,
            expid: self.expid})
            .then(res1 => {
              self.expense = _.cloneDeep(res1)
              self.loaded = true
            })
        })
        .catch(err => self.$error(err))
    },
    close () {
      const self = this
      if (self.modified) {
        const yesHandler = () => {
          self.$router.replace(getBackRoute(self))
          self.closeConfirmation()
        }

        const noHandler = () => {
          self.closeConfirmation()
        }

        this.showConfirmation({
          message: 'Are you sure?',
          title: 'Closing. Modified Business Trip Request Expense will not saved',
          buttons: [{label: 'Yes', handler: yesHandler}, {label: 'No', handler: noHandler}]
        })
      } else {
        self.$router.replace(getBackRoute(self))
      }
    },
    refresh () {
      const self = this

      self.loaded = false
      self.getExpenseById({vueinstance: self,
        id: self.id,
        empid: self.empid,
        expid: self.expid})
        .then(res => {
          self.expense = _.cloneDeep(res)
          self.loaded = true
          self.modified = false
        })
        .catch(err => self.$error(err))
    },
    change () {
      this.modified = true
    },
    save (expense) {
      const self = this

      self.updateExpense({vueinstance: self,
        id: self.id,
        empid: self.empid,
        expid: self.expid,
        exp: expense})
        .then(res => {
          self.loaded = false
          self.expense = _.cloneDeep(res)
          self.loaded = true
          self.modified = false
          self.$success('Business Trip Request Expense saved')
          self.$router.replace(getBackRoute(self))
        })
        .catch(err => self.$error(err))
    }
  },
  mounted () {
    if (!this.loaded) {
      this.loadResources()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.loadResources()
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/business-trip/BusinessTripRequestExpenseDetail.vue